import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconHamburgerLong = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			width: 11,
			height: 2,
			rx: 1,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 4,
			width: 11,
			height: 2,
			rx: 1,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 9,
			width: 11,
			height: 2,
			rx: 1,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 13,
			width: 11,
			height: 2,
			rx: 1,
			fill: "currentColor"
		})
	]
});
export default SvgIconHamburgerLong;
